import { render, staticRenderFns } from "./JImageUploadNew.vue?vue&type=template&id=5b7018d2&scoped=true"
import script from "./JImageUploadNew.vue?vue&type=script&lang=js"
export * from "./JImageUploadNew.vue?vue&type=script&lang=js"
import style0 from "./JImageUploadNew.vue?vue&type=style&index=0&id=5b7018d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7018d2",
  null
  
)

export default component.exports